import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MaterialButton from "../../../../../components/MaterialButton";
import request from "graphql-request";
import BASEURL from "../../../../../pages/Utils/Baseurl";
import { UpdateRemarkStatus } from "../data";
import Swal from "sweetalert2";
import { useLoading } from "../../../../../context/LodingContext";
import RoleAccess from "../../../../function/RoleAccess";

export default function RemarksDialog({
  open,
  setOpen,
  productDatas,
  setProductDatas,
  tabValue,
  fetchMallListData
}) {
  const handleClose = () => setOpen(false);
  const { setCirleLoading } = useLoading();

  const handleremarkstatus = async (id, values) => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, UpdateRemarkStatus, {
        input: {
          remarkId: Number(id),
          status: values,
        },
      });

      const success = res.UpdateRemarkStatus.success;
      const message = res.UpdateRemarkStatus.message;
      if (success) {
        Swal.fire({
          position: "top",
          icon: success ? "success" : "error",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          fetchMallListData()
          setOpen(false);
          setProductDatas(null);
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        }).then(() => {});
      }
    } catch (error) {
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, p: 1 },
        }}
      >
        {/* Top Section with Title + Close Icon */}
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pb: 1,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {productDatas?.product.productName}
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Description */}
        <DialogContent dividers>
          <Typography
            variant="body1"
            sx={{ fontSize: "14px", fontWeight: "500" }}
          >
            {productDatas?.remark?.text}
          </Typography>
        </DialogContent>

        {tabValue != "myentry" && (
          <RoleAccess
            modelName="Product Display Compliance Screen"
            component="ApproveProductCompliance"
          >
            <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                onClick={() =>
                  handleremarkstatus(productDatas?.remark?.id, "approved")
                }
              >
                Accept
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                onClick={() =>
                  handleremarkstatus(productDatas?.remark?.id, "reject")
                }
              >
                Reject
              </MaterialButton>
            </DialogActions>
          </RoleAccess>
        )}
      </Dialog>
    </>
  );
}
